import React from 'react';
import { useServices } from '../../hooks/useAdminData';
import { FaShower, FaCut, FaCrown, FaCheck, FaPaw } from 'react-icons/fa';
import './Services.scss';

const Services: React.FC = () => {
  const services = useServices();
  
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const getServiceIcon = (serviceId: string) => {
    switch (serviceId) {
      case '5-star-bath':
        return FaShower({ size: 32 });
      case 'premium-touch-up':
        return FaCut({ size: 32 });
      case 'royal-treatment':
        return FaCrown({ size: 32 });
      default:
        return FaShower({ size: 32 });
    }
  };

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="services-header">
          <h2 className="services-title">
            <span className="our-text">OUR</span> <span className="services-text">SERVICES</span>
          </h2>
          <p className="services-subtitle">
            Choose the perfect grooming experience for your beloved pet. Every service is all-inclusive, pre-easy, complete care.
          </p>
        </div>
        
        {/* Service Cards */}
        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className={`service-card ${service.id === '5-star-bath' ? 'star-bath' : service.id}`}>
              <div className={`service-icon ${service.id === '5-star-bath' ? 'star-bath' : service.id}`}>
                {getServiceIcon(service.id)}
              </div>
              <h3 className="service-name">{service.name}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, index) => {
                  let highlightedFeature = feature.replace(
                    /high-quality shampoo & conditioner/gi,
                    '<span class="highlighted-text">high-quality shampoo & conditioner</span>'
                  );
                  
                  highlightedFeature = highlightedFeature.replace(
                    /Full body brushing/gi,
                    '<span class="highlighted-text">Full body brushing</span>'
                  );
                  
                  highlightedFeature = highlightedFeature.replace(
                    /ear cleaning & care/gi,
                    '<span class="highlighted-text">ear cleaning & care</span>'
                  );
                  
                  highlightedFeature = highlightedFeature.replace(
                    /oral care/gi,
                    '<span class="highlighted-text">oral care</span>'
                  );
                  
                  // Destacar "Nail clipping & filing" apenas no Mini-Groom
                  if (service.id === 'premium-touch-up') {
                    highlightedFeature = highlightedFeature.replace(
                      /Nail clipping & filing/gi,
                      '<span class="highlighted-text">Nail clipping & filing</span>'
                    );
                    
                    highlightedFeature = highlightedFeature.replace(
                      /Paw pad cleaning & shave/gi,
                      '<span class="highlighted-text">Paw pad cleaning & shave</span>'
                    );
                    
                    highlightedFeature = highlightedFeature.replace(
                      /Small shear trim/gi,
                      '<span class="highlighted-text">Small shear trim</span>'
                    );
                  }
                  
                  // Destacar "full-body trim or shave" apenas no Full Groom
                  if (service.id === 'royal-treatment') {
                    highlightedFeature = highlightedFeature.replace(
                      /Nail clipping & filing/gi,
                      '<span class="highlighted-text">Nail clipping & filing</span>'
                    );
                    
                    highlightedFeature = highlightedFeature.replace(
                      /Paw pad cleaning & shave/gi,
                      '<span class="highlighted-text">Paw pad cleaning & shave</span>'
                    );
                    
                    highlightedFeature = highlightedFeature.replace(
                      /Small shear trim/gi,
                      '<span class="highlighted-text">Small shear trim</span>'
                    );
                    
                    highlightedFeature = highlightedFeature.replace(
                      /full-body trim or shave/gi,
                      '<span class="highlighted-text">full-body trim or shave</span>'
                    );
                    
                    highlightedFeature = highlightedFeature.replace(
                      /Custom haircut & scissor finishing/gi,
                      '<span class="highlighted-text">Custom haircut & scissor finishing</span>'
                    );
                  }
                  
                  highlightedFeature = highlightedFeature.replace(
                    /towel wrap/gi,
                    '<span class="highlighted-text">towel wrap</span>'
                  );
                  
                  highlightedFeature = highlightedFeature.replace(
                    /hand blow-dry\/fluff-dry & 5-minute massage/gi,
                    '<span class="highlighted-text">hand blow-dry/fluff-dry & 5-minute massage</span>'
                  );
                  
                  highlightedFeature = highlightedFeature.replace(
                    /premium cologne/gi,
                    '<span class="highlighted-text">premium cologne</span>'
                  );
                  
                  highlightedFeature = highlightedFeature.replace(
                    /bandana, bow or accessory/gi,
                    '<span class="highlighted-text">bandana, bow or accessory</span>'
                  );
                  
                  return (
                    <li key={index} className="feature-item">
                      {FaCheck({ className: "check-icon", size: 16 })}
                      <span dangerouslySetInnerHTML={{ __html: highlightedFeature }} />
                    </li>
                  );
                })}
              </ul>
              <button className="book-now-btn" onClick={() => scrollToSection('contact')} aria-label="Book an appointment">
                <span className="paw-icon" aria-hidden="true">{FaPaw({ size: 16 })}</span>
                Book Now
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
